import React from "react";
import Reports from "../../components/user/reports";
import Layout from "../../components/layouts/verticalLayout";

const ReportsPage = (props) => {
  return <Layout body={<Reports />} />;
};

ReportsPage.propTypes = {};

export default ReportsPage;
